import * as Types from '../../../generated/graphql/types';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AtsSharedGetCountriesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AtsSharedGetCountriesQuery = { __typename?: 'Query', countries?: Array<{ __typename?: 'CountryNode', name: string, alpha_2: string }> | null };


export const AtsSharedGetCountriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AtsSharedGetCountries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alpha_2"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useAtsSharedGetCountriesQuery__
 *
 * To run a query within a React component, call `useAtsSharedGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtsSharedGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtsSharedGetCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAtsSharedGetCountriesQuery(baseOptions?: Apollo.QueryHookOptions<AtsSharedGetCountriesQuery, AtsSharedGetCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AtsSharedGetCountriesQuery, AtsSharedGetCountriesQueryVariables>(AtsSharedGetCountriesDocument, options);
      }
export function useAtsSharedGetCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AtsSharedGetCountriesQuery, AtsSharedGetCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AtsSharedGetCountriesQuery, AtsSharedGetCountriesQueryVariables>(AtsSharedGetCountriesDocument, options);
        }
export type AtsSharedGetCountriesQueryHookResult = ReturnType<typeof useAtsSharedGetCountriesQuery>;
export type AtsSharedGetCountriesLazyQueryHookResult = ReturnType<typeof useAtsSharedGetCountriesLazyQuery>;
export type AtsSharedGetCountriesQueryResult = Apollo.QueryResult<AtsSharedGetCountriesQuery, AtsSharedGetCountriesQueryVariables>;